module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedSemiBold.9029ccb.eot";